import React from 'react';

const DialogButtonGroupSeparator = () => <div className="ws-ui-dialog-button-group-separator" />;

export default DialogButtonGroupSeparator;
